import { render, staticRenderFns } from "./KanbanFilters.vue?vue&type=template&id=67b532ed&scoped=true&"
import script from "./KanbanFilters.vue?vue&type=script&lang=js&"
export * from "./KanbanFilters.vue?vue&type=script&lang=js&"
import style0 from "./KanbanFilters.vue?vue&type=style&index=0&id=67b532ed&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b532ed",
  null
  
)

export default component.exports